import React from 'react';
import { bonuses } from '../data/content';
import { ImageSlot } from './ImageSlot';
import { SectionHeading } from './SectionHeading';
type BonusesSectionProps = {
  bonusCovers: string[];
};
export function BonusesSection({
  bonusCovers
}: BonusesSectionProps) {
  return <section aria-labelledby="bonuses-title" className="bg-white py-12 md:py-20" data-id="element-18" data-mp="qtt7eqcv6v9u">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-19" data-mp="qvw2vpwsdgly">
        <SectionHeading id="bonuses-title" eyebrow={bonuses.eyebrow} title={bonuses.title} sub={bonuses.sub} data-id="element-20" data-mp="14sj5a87icyz9" />

        <ul className="mt-8 grid gap-4 md:mt-12 md:grid-cols-2" data-id="element-21" data-mp="ztpwuu72vy5y">
          {bonuses.items.map((b, i) => {
          const featured = i === 0;
          return <li key={b.label} className={`flex flex-col overflow-hidden rounded-xl border bg-white sm:flex-row sm:items-center sm:gap-6 sm:p-5 ${featured ? 'border-2 border-sun md:col-span-2 md:gap-8 md:p-7' : 'border-hair'}`} data-id="element-22" data-mp="19k14aqpz0phl" data-mpi={i}>
                <div className={`flex aspect-[4/3] w-full shrink-0 items-center justify-center bg-mist p-3 sm:aspect-square sm:rounded-lg sm:p-0 ${featured ? 'sm:w-40 md:w-48' : 'sm:w-36'}`} data-id="element-23" data-mp="3prdd65niktuz">
                  <ImageSlot url={bonusCovers[i]} alt={`${b.title} cover`} slotName={`bonusCovers[${i}]`} fit="contain" className="rounded-lg" data-id="element-24" data-mp="7kfkeyuw6bms" />
                </div>
                <div className="min-w-0 p-5 sm:p-0" data-id="element-25" data-mp="chph8zkm1pkn">
                  <span className="inline-block rounded-md bg-sun px-2 py-1 font-display text-[11px] font-black tracking-[0.08em] text-ink" data-id="element-26" data-mp="gklro2zzyfdi">{b.label}</span>
                  <p className="mt-3 text-[15px] font-semibold text-coral-ink" data-id="element-27" data-mp="leg9f0w1kk9y">{b.hook}</p>
                  <h3 className={`mt-1 font-display font-extrabold uppercase leading-snug tracking-tight text-brand ${featured ? 'text-[18px] md:text-[24px]' : 'text-[17px]'}`} data-id="element-28" data-mp="qdb00p093d4m">
                    {b.title}
                  </h3>
                  <p className="mt-2 text-[16px] leading-relaxed text-ink/75" data-id="element-29" data-mp="5m5sw92fpbl4">{b.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}